import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import CartaPorteMercanciaPedimentosForm from './CartaPorteMercanciaPedimentosForm';
import CartaPorteMercanciasPedimentosList from './CartaPorteMercanciasPedimentosList';

class CartaPorteMercanciaPedimentosManager extends Component {

  state = {}

  handleOnAdd = (data) => {
    const { Pedimentos = [] } = this.props.data;

    const newData = Pedimentos.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      Pedimentos: data
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { Pedimentos =  [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Pedimentos</legend>

          <CartaPorteMercanciaPedimentosForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <CartaPorteMercanciasPedimentosList
            data={ Pedimentos }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default CartaPorteMercanciaPedimentosManager;